import React from "react";
import { useLocale } from "lib/hooks/useLocale";
import { GenericDialog } from "components/common/dialogs/GenericDialog";
import { X, SealPercent } from "@phosphor-icons/react";
import Price from "components/common/Price";

interface CheckoutExitPopupProps {
  isOpen: boolean;
  closePopup: () => void;
  closeCheckout: () => void;
  savingsAmount?: number;
}

const CheckoutExitPopup: React.FC<CheckoutExitPopupProps> = ({
  isOpen,
  closePopup,
  closeCheckout,
  savingsAmount,
}) => {
  const { t } = useLocale();

  const hasSavings = Boolean(savingsAmount && savingsAmount > 0);

  return (
    <GenericDialog
      isOpen={isOpen}
      setIsOpen={closePopup}
      translateAxis="y"
      dialogOverlay
      closeOnOverlayClick
      modalType="EXIT_CONFIRMATION"
      customClass="!overflow-visible md:!top-auto md:absolute rounded-t-2xl !p-0 max-h-[85vh]"
    >
      <div className="flex flex-col gap-4 px-5 pt-5 pb-6" style={{ WebkitFontSmoothing: "antialiased" }}>
        <div className="flex flex-col gap-1">
          <div className="flex items-start justify-between">
            <h1 className="text-text-lg-semibold text-zinc-900">{t("exit_checkout_confirm_header")}</h1>
            <div className="flex items-center justify-center flex-shrink-0" style={{ height: 20 }}>
              <X size={16} weight="bold" className="text-zinc-500 cursor-pointer" onClick={closePopup} />
            </div>
          </div>

          {hasSavings ? (
            <p className="flex w-full items-center gap-1 text-text-sm-semibold text-yellow-dark">
              <SealPercent className="h-4 w-4 flex-shrink-0" weight="fill" />
              {t("about_to_lose_savings")}&nbsp;
              <Price total={savingsAmount ?? ""} />
              &nbsp;{t("in_savings")}
            </p>
          ) : (
            <p className="text-text-sm-medium pr-8 text-zinc-500">{t("exit_checkout_confirm_body")}</p>
          )}
        </div>

        <div className="flex flex-col gap-2">
          <button
            type="button"
            className="w-full cursor-pointer py-3 rounded-[10px] text-text-md-semibold text-btnPrimaryText touch-manipulation bg-primary-dark active:[background:color-mix(in_srgb,var(--flo-primary-dark-color)_80%,#71717A_20%)]"
            onClick={closePopup}>
            {hasSavings ? t("stay") : t("stay_in_checkout")}
          </button>
          <button
            type="button"
            className="w-full cursor-pointer py-3 rounded-[10px] text-text-md-semibold touch-manipulation border border-zinc-900/20 text-zinc-900/70 active:bg-zinc-500/10"
            onClick={() => {
              closePopup();
              closeCheckout();
            }}>
            {t("leave_checkout")}
          </button>
        </div>
      </div>
    </GenericDialog>
  );
};

export default CheckoutExitPopup;
